import cardValidator from 'card-validator'

export function digitsOnly (value) {
  return String(value || '').replace(/\D/g, '')
}

export function cardLast4 (ccnumber) {
  const digits = digitsOnly(ccnumber)
  return digits.length >= 4 ? digits.slice(-4) : ''
}

export function formatCardNumber (value) {
  const digits = digitsOnly(value)
  const info = cardValidator.number(digits)
  const gaps = info.card?.gaps || [4, 8, 12]
  const maxLength = Math.max(...(info.card?.lengths || [16]))
  const clipped = digits.slice(0, maxLength)
  let formatted = ''
  for (let i = 0; i < clipped.length; i++) {
    if (gaps.includes(i) && formatted.length) formatted += ' '
    formatted += clipped[i]
  }
  return formatted
}

export function formatExpiryInput (value) {
  const digits = digitsOnly(value).slice(0, 4)
  if (digits.length < 3) return digits
  return `${digits.slice(0, 2)} / ${digits.slice(2)}`
}

export function getCardMeta ({ ccnumber, ccexp, cvv } = {}) {
  const numberDigits = digitsOnly(ccnumber)
  const expiryDigits = digitsOnly(ccexp)
  const cvvDigits = digitsOnly(cvv)
  const number = cardValidator.number(numberDigits)
  const expiry = cardValidator.expirationDate(expiryDigits)
  const cvvLength = number.card?.code?.size || 3
  const cvvResult = cardValidator.cvv(cvvDigits, cvvLength)

  return {
    cardType: number.card?.niceType || '',
    cvvLength,
    formattedNumber: formatCardNumber(numberDigits),
    formattedExpiry: formatExpiryInput(expiryDigits),
    numberValid: number.isValid,
    numberPotentiallyValid: number.isPotentiallyValid,
    numberComplete: (number.card?.lengths || [16]).includes(numberDigits.length),
    expiryValid: expiry.isValid,
    expiryPotentiallyValid: expiry.isPotentiallyValid,
    expiryComplete: expiryDigits.length === 4,
    cvvValid: cvvResult.isValid,
    cvvPotentiallyValid: cvvResult.isPotentiallyValid,
    cvvComplete: cvvDigits.length === cvvLength,
    isCardValid: number.isValid && expiry.isValid && cvvResult.isValid
  }
}

export function isCardPaymentReady (method = {}) {
  return getCardMeta(method).isCardValid
}
